import { render, staticRenderFns } from "./ActivityFeedCardV2.vue?vue&type=template&id=212b41eb&scoped=true"
import script from "./ActivityFeedCardV2.vue?vue&type=script&lang=js"
export * from "./ActivityFeedCardV2.vue?vue&type=script&lang=js"
import style0 from "./ActivityFeedCardV2.vue?vue&type=style&index=0&id=212b41eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b41eb",
  null
  
)

export default component.exports